import {getToolEngine} from "@shared/GenericTools/ToolEngineRegistry";

export function isToolSubmissionReady(toolInstance, toolDefinition, enginePayload, workContext = {}) {
	if (!toolInstance?.config || !toolDefinition || !enginePayload) return false
	try {
		const engine = getToolEngine(toolDefinition.engine).implementation
		const context = {...workContext, submissionDate: new Date().toISOString().slice(0, 10), definition: toolDefinition}
		return engine.prepareSubmission(enginePayload, toolInstance.config, context).errors.length === 0
	} catch (error) {
		return false
	}
}
